export default __webpack_public_path__ + "static/media/ic-descuento.5dea8e43.svg";